// Version : 0.0.5
// Author : ARAVINDHAN
// LastEdit : KARTHEESWARAN
// MODFIED DATA : 13-08-2025
import PurposeOfLoanTypeActionTypes from './purpose-of-loan-type.types';

/** *************** GET PURPOSE OF LOAN TYPE LIST START ***************** */
export const getPurposeOfLoanTypeStart = (purposeOfLoanType: any) => ({
	type: PurposeOfLoanTypeActionTypes.GET_PURPOSE_OF_LOAN_TYPE_START,
	payload: purposeOfLoanType,
});

export const getPurposeOfLoanTypeSuccess = (Success: any) => ({
	type: PurposeOfLoanTypeActionTypes.GET_PURPOSE_OF_LOAN_TYPE_SUCCESS,
	payload: Success,
});

export const getPurposeOfLoanTypeFailure = (error: any) => ({
	type: PurposeOfLoanTypeActionTypes.GET_PURPOSE_OF_LOAN_TYPE_FAILURE,
	payload: error,
});

export const getPurposeOfLoanTypeResponseReset = () => ({
	type: PurposeOfLoanTypeActionTypes.GET_PURPOSE_OF_LOAN_TYPE_RESPONSE_RESET,
});

export const getPurposeOfLoanTypeResponseChanged = () => ({
	type: PurposeOfLoanTypeActionTypes.GET_PURPOSE_OF_LOAN_TYPE_RESPONSE_CHANGED,
});
/** *************** GET PURPOSE OF LOAN TYPE LIST END ***************** */

/** *************** DELETE PURPOSE OF LOAN TYPE LIST START ***************** */
export const deletePurposeOfLoanTypeStart = (deletepurposeOfLoanType: any) => ({
	type: PurposeOfLoanTypeActionTypes.DELETE_PURPOSE_OF_LOAN_TYPE_START,
	payload: deletepurposeOfLoanType,
});

export const deletePurposeOfLoanTypeSuccess = (Success: any) => ({
	type: PurposeOfLoanTypeActionTypes.DELETE_PURPOSE_OF_LOAN_TYPE_SUCCESS,
	payload: Success,
});

export const deletePurposeOfLoanTypeFailure = (error: any) => ({
	type: PurposeOfLoanTypeActionTypes.DELETE_PURPOSE_OF_LOAN_TYPE_FAILURE,
	payload: error,
});

export const deletePurposeOfLoanTypeResponseReset = () => ({
	type: PurposeOfLoanTypeActionTypes.DELETE_PURPOSE_OF_LOAN_TYPE_RESPONSE_RESET,
});

export const deletePurposeOfLoanTypeResponseChanged = () => ({
	type: PurposeOfLoanTypeActionTypes.DELETE_PURPOSE_OF_LOAN_TYPE_RESPONSE_CHANGED,
});
/** *************** DELETE PURPOSE OF LOAN TYPE LIST END ***************** */

/** *************** ADD PURPOSE OF LOAN TYPE LIST START ***************** */

export const addPurposeOfLoanTypeStart = (purposeOfLoanType: any) => ({
	type: PurposeOfLoanTypeActionTypes.ADD_PURPOSE_OF_LOAN_TYPE_START,
	payload: purposeOfLoanType,
});

export const addPurposeOfLoanTypeSuccess = (Success: any) => ({
	type: PurposeOfLoanTypeActionTypes.ADD_PURPOSE_OF_LOAN_TYPE_SUCCESS,
	payload: Success,
});

export const addPurposeOfLoanTypeFailure = (error: any) => ({
	type: PurposeOfLoanTypeActionTypes.ADD_PURPOSE_OF_LOAN_TYPE_FAILURE,
	payload: error,
});

export const addPurposeOfLoanTypeResponseReset = () => ({
	type: PurposeOfLoanTypeActionTypes.ADD_PURPOSE_OF_LOAN_TYPE_RESPONSE_RESET,
});

export const addPurposeOfLoanTypeResponseChanged = () => ({
	type: PurposeOfLoanTypeActionTypes.ADD_PURPOSE_OF_LOAN_TYPE_RESPONSE_CHANGED,
});
/** *************** ADD PURPOSE OF LOAN TYPE LIST END ***************** */

/** ***************** FETCH PURPOSE OF LOAN TYPE DETAILS START *********************** */
export const fetchPurposeOfLoanTypeDetailsStart = (fetchData: any) => ({
	type: PurposeOfLoanTypeActionTypes.FETCH_PURPOSE_OF_LOAN_TYPE_DETAILS_START,
	payload: fetchData,
});

export const fetchPurposeOfLoanTypeDetailsSuccess = (successData: any) => ({
	type: PurposeOfLoanTypeActionTypes.FETCH_PURPOSE_OF_LOAN_TYPE_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchPurposeOfLoanTypeDetailsFailure = (failureData: any) => ({
	type: PurposeOfLoanTypeActionTypes.FETCH_PURPOSE_OF_LOAN_TYPE_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchPurposeOfLoanTypeDetailsResponseResetStart = () => ({
	type: PurposeOfLoanTypeActionTypes.FETCH_PURPOSE_OF_LOAN_TYPE_DETAILS_RESPONSE_RESET,
});

export const fetchPurposeOfLoanTypeDetailsResponseChanged = () => ({
	type: PurposeOfLoanTypeActionTypes.FETCH_PURPOSE_OF_LOAN_TYPE_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH PURPOSE OF LOAN TYPE DETAILS END *********************** */

/** ***************** UPDATE PURPOSE OF LOAN TYPE DETAILS START *********************** */
export const updatePurposeOfLoanTypeDetailsStart = (updateData: any) => ({
	type: PurposeOfLoanTypeActionTypes.UPDATE_PURPOSE_OF_LOAN_TYPE_DETAILS_START,
	payload: updateData,
});

export const updatePurposeOfLoanTypeDetailsSuccess = (successData: any) => ({
	type: PurposeOfLoanTypeActionTypes.UPDATE_PURPOSE_OF_LOAN_TYPE_DETAILS_SUCCESS,
	payload: successData,
});

export const updatePurposeOfLoanTypeDetailsFailure = (failureData: any) => ({
	type: PurposeOfLoanTypeActionTypes.UPDATE_PURPOSE_OF_LOAN_TYPE_DETAILS_FAILURE,
	payload: failureData,
});

export const updatePurposeOfLoanTypeDetailsResponseResetStart = () => ({
	type: PurposeOfLoanTypeActionTypes.UPDATE_PURPOSE_OF_LOAN_TYPE_DETAILS_RESPONSE_RESET,
});

export const updatePurposeOfLoanTypeDetailsResponseChanged = () => ({
	type: PurposeOfLoanTypeActionTypes.UPDATE_PURPOSE_OF_LOAN_TYPE_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE PURPOSE OF LOAN TYPE DETAILS END *********************** */
